const restaurants = [
	{
		path: 'restaurants',
		name: 'restaurants.index',
		component: () => import('@/views/restaurant/List.vue'),
		meta: { layout: 'content' },
	},
	{
		path: 'restaurants/create',
		name: 'restaurants.create',
		component: () => import('@/views/restaurant/Create.vue'),
		meta: { layout: 'content' },
	},
]

export default restaurants
